// extracted by mini-css-extract-plugin
export default {"main":"main--HE1iW","background":"background--g7tbB"};